export default {
  set(state, { data }) {
    state.movements = data;
  },
  show(state, { data }) {
    state.movement = data;
  },
  getPage(state, { data }) {
    state.page = data
  }
}